<template>
  <editor
    id="tinymce-editor"
    :disabled="disabled"
    :init="tinymceConfig"
    v-model="content"
  ></editor>
</template>
  
  <script>
  import Editor from '@tinymce/tinymce-vue';
  
  export default {
    components: {
      Editor
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      init: {
        type: Object,
        default: {}
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      value: function (val) {
        this.content = val;
      },
      content: function (val) {
        this.$emit('input', val);
      },
    },
    created() {
      this.content = this.value
      if(this.init && Object.entries(this.init).length) {
        this.tinymceConfig = Object.assign(this.tinymceConfig, this.init)
      }
    },
    data() {
      return {
        content: '',
        tinymceConfig: {
          height: 500,
          menubar: false,
          toolbar_mode: 'floating',
          script_url: '/tinymce/tinymce.min.js',
          skin_url: '/tinymce/skins/ui/oxide',
          content_css: '/tinymce/skins/content/default/content.min.css',
        }
      };
    }
  };
  </script>